import { render, staticRenderFns } from "./AuthorizationLetter.vue?vue&type=template&id=466e9ac2&scoped=true"
import script from "./AuthorizationLetter.vue?vue&type=script&lang=js"
export * from "./AuthorizationLetter.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationLetter.vue?vue&type=style&index=0&id=466e9ac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466e9ac2",
  null
  
)

export default component.exports